import React, { useEffect, useState } from 'react'
import { Form, Spinner, Table } from 'react-bootstrap'
import SplitPane from 'react-split-pane'
import { studyLabManagementFileServices } from '../../../APIServices/studyLabManagementFileServices';
import { useParams } from 'react-router';
import Papa from "papaparse";
import * as XLSX from "xlsx";
import { studyEventFormSchemaServices } from '../../../APIServices/studyEventFormSchemaServices';
import { studySiteManagementServices } from '../../../APIServices/CTMS/SiteManagement/studySiteManagementServices';
import { studyLevelFormManagementServices } from '../../../APIServices/studyLevelFormManagementServices';
import { studySubjectManagementServices } from '../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices';
import { usersOnboardingService } from '../../../APIServices/usersOnboarding';
import { isHTMLIdentifier } from "../../../utils/universalFunction";
import MapperPreview from './MapperPreview';
import { studySiteDataEntryServices } from '../../../APIServices/studySiteDataEntryServices';
import { PageLoader } from '../../../Components/NoDataFoundTable/NoDataFoundTable';

const ColumnMapping = ({ }) => {
  const [dataEntryMessage, setDataEntryMessage] = useState("");
  const [studyLabel, setStudyLabel] = useState("");
  const [datasetType, setDatasetType] = useState("");
  const [level, setLevel] = useState("");
  const [dataEntryType, setDataEntryType] = useState("");
  const [fileList, setFileList] = useState([]);
  const [fileLoader, setFileLoader] = useState(false);
  const [eventList, setEventList] = useState([]);
  const [eventLoader, setEventLoader] = useState(false);
  const [subjectList, setSubjectList] = useState([]);
  const [subjectLoader, setSubjectLoader] = useState(false);
  const [siteList, setSiteList] = useState([]);
  const [siteLoader, setSiteLoader] = useState(false);
  const [formFieldList, setFormFieldList] = useState([]);
  const [formFieldLoader, setFormFieldLoader] = useState(false);
  const [fileId, setFileId] = useState("");
  const [fileUniqueId, setFileUniqueId] = useState("");
  const [formId, setFormId] = useState("");
  const [formVersion, setFormVersion] = useState("");
  const [formType, setFormType] = useState("");
  const [siteId, setSiteId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [subjectLabel, setSubjectLabel] = useState("");
  const [schemaId, setSchemaId] = useState("");
  const [eventId, setEventId] = useState("");
  const [timePointUniqueId, setTimePointUniqueId] = useState("");
  const [eventName, setEventName] = useState("");
  const [timePointId, setTimePointId] = useState("");
  const [eventRepeat, setEventRepeat] = useState("");
  const [formRepeat, setFormRepeat] = useState("");
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState("");
  const [dataLoading, setDataLoading] = useState(false);
  const [sourceData, setSourceData] = useState([]);
  const [previewData, setPreviewData] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [columnMappings, setColumnMappings] = useState({});

  const { studyId } = useParams()
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));

  const isStudyLevel = level === "study";
  const isSiteLevel = level === "site";
  const isSubjectLevel = level === "subject";
  const isEventLevel = level === "event";

  const showDynamicSite = isSiteLevel || isSubjectLevel || isEventLevel;
  const showDynamicSubject = isSubjectLevel || isEventLevel;
  const showDynamicEvent = isEventLevel;
  const showColumnSite = isStudyLevel;
  const showColumnSubject = isStudyLevel || isSiteLevel;
  const showColumnEvent = isStudyLevel || isSiteLevel || isSubjectLevel;
  const showColumnTimePoint = isStudyLevel || isSiteLevel || isSubjectLevel;
  const shouldShowSubjectEventColumn = isStudyLevel || ((isSiteLevel || isSubjectLevel) && !!subjectId);

  const getStudyLabManagementData = async (e) => {
    setFileLoader(true)
    let data = await studyLabManagementFileServices.getStudyLabManagementData("active", studyId, StudyMode, "", null, null, datasetType);
    setFileList(data?.data || []);
    setFileLoader(false)
  };

  const filteredFileList = datasetType
    ? fileList?.filter((item) => item?.datasetType === datasetType)
    : [];

  const getStudySiteBasedonAccess = async () => {
    setSiteLoader(true)
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(studyId, "edc", StudyMode)
    let sites = data?.data || []
    setSiteList(sites)
    setSiteLoader(false)
  }

  const getStudySubjectRowData = async (e) => {
    setSubjectLoader(true)
    let data = await studySubjectManagementServices.getStudySubjectRowData(
      "active",
      studyId,
      siteId,
      StudyMode
    );
    setSubjectList(data?.data || []);
    setSubjectLoader(false)
  };

  const getEventBasedonSchema = async (e) => {
    setEventLoader(true)
    let data = await studyEventFormSchemaServices.getEventBasedonSchema(studyId, schemaId, "all");
    setEventList(data?.data || []);
    setEventLoader(false)
  };

  const checkEventLevelFormDataEntry = async (e) => {
    setFormFieldLoader(true)
    let userData = {}
    userData.studyId = studyId
    userData.siteId = siteId
    userData.subjectId = subjectId
    userData.eventId = eventId
    userData.timePointUniqueId = timePointUniqueId
    userData.formId = formId
    userData.formVersion = formVersion
    userData.mode = StudyMode
    userData.level = level
    let data = await studySiteDataEntryServices.checkEventLevelFormDataEntry(userData);
    if (data?.count > 0) {
      setDataEntryMessage(
        `This form cannot be uploaded or used for data entry for the selected Site > Subject > Event${timePointUniqueId ? " > Time Point ID" : ""
        }.`
      );
    } else {
      setDataEntryMessage("")
    }
    setFormFieldLoader(false)
  };

  useEffect(() => {
    if (!formId || !formVersion) return;
    if (level === "event") {
      checkEventLevelFormDataEntry();
    }
  }, [
    level,
    siteId,
    subjectId,
    eventId,
    formId,
    formVersion,
    timePointUniqueId
  ]);

  const getStudyLevelFormFieldsByVersion = async (formId, formVersion) => {
    setFormFieldLoader(true)
    let data = await studyLevelFormManagementServices.getStudyLevelFormFieldsByVersion(
      studyId,
      formId,
      formVersion
    );
    if (data === "AbortError") {
      setFormFieldList([]);
    } else {
      setFormFieldList(data?.data?.formFields || []);
    }
    setFormFieldLoader(false)
  };

  const normalizedFormFieldList = Array.isArray(formFieldList) ? formFieldList : [];

  const setFieldMapping = (fieldId, mappingType, column) => {
    setColumnMappings(prev => ({
      ...prev,
      fields: {
        ...(prev.fields || {}),
        [fieldId]: {
          ...(prev.fields?.[fieldId] || {}),
          [mappingType]: column
        }
      }
    }));
  };

  const setMetadataMapping = (mappingType, column) => {
    setColumnMappings(prev => ({
      ...prev,
      metadata: {
        ...(prev.metadata || {}),
        [mappingType]: column
      }
    }));
  };

  const findStudyLabel = async () => {
    let data = await usersOnboardingService.findStudyLabel(studyId);
    setStudyLabel(data?.data || "");
  };

  const extractColumns = (data) => {
    if (!data?.length) return [];
    const keys = new Set();

    data.forEach((row) => {
      Object.keys(row || {}).forEach((key) => keys.add(key));
    });

    return [...keys];
  };

  const convertLabDataToWideFormat = (data = []) => {
    if (!Array.isArray(data) || !data.length) {
      return [];
    }
    const groups = new Map();
    data.forEach((item) => {
      const groupKey = Object.keys(item)
        .filter((key) => key !== "LBTEST" && key !== "LBORRES")
        .sort()
        .map((key) => `${key}:${item[key] ?? ""}`)
        .join("|");
      if (!groups.has(groupKey)) {
        const baseRow = {};
        Object.keys(item)
          .filter((key) => key !== "LBTEST" && key !== "LBORRES")
          .forEach((key) => {
            baseRow[key] = item[key];
          });
        groups.set(groupKey, baseRow);
      }
      const resultRow = groups.get(groupKey);
      const testName = item?.LBTESTCD;
      if (testName) {
        resultRow[testName] = item?.LBORRES ?? "";
      }
    });
    return Array.from(groups.values());
  };

  const loadFileFromS3 = async (url) => {
    try {
      setDataLoading(true);
      setError("");
      setColumns([]);
      const extension = url.split("?")[0].split(".").pop().toLowerCase();
      if (extension === "csv") {
        const response = await fetch(url);
        const csvText = await response.text();
        Papa.parse(csvText, {
          header: true,
          skipEmptyLines: true,
          complete: ({ data }) => {
            const parsedRows = data || [];
            setSourceData(parsedRows);
            setColumns(extractColumns(parsedRows));
            setDataLoading(false);
          },
          error: () => {
            setError("Failed to parse CSV");
            setDataLoading(false);
          },
        });
        return;
      }
      if (extension === "json") {
        const response = await fetch(url);
        const json = await response.json();
        const data = Array.isArray(json) ? json : json.data || [];
        setSourceData(data);
        setColumns(extractColumns(data));
        setDataLoading(false);
        return;
      }
      if (extension === "xls" || extension === "xlsx") {
        const response = await fetch(url);
        const buffer = await response.arrayBuffer();
        const workbook = XLSX.read(buffer, { type: "array" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        const data = XLSX.utils.sheet_to_json(sheet, {
          defval: null,
        });
        let finalData = datasetType === "column" ? convertLabDataToWideFormat(data) : data
        setSourceData(finalData);
        setColumns(extractColumns(finalData));
        setDataLoading(false);
        return;
      }
      setError("Unsupported file type.");
      setDataLoading(false);
    } catch (err) {
      console.error(err);
      setError("Unable to load file.");
      setDataLoading(false);
    }
  };

  const handleFileChange = (fileId) => {
    let checkFile = fileList?.find(item => item.fileId === fileId)
    if (checkFile) {
      getStudyLevelFormFieldsByVersion(checkFile?.formId, checkFile?.formVersion)
      setFileId(checkFile?.fileId)
      setFileUniqueId(checkFile?._id)
      setFormId(checkFile?.formId)
      setFormVersion(checkFile?.formVersion)
      setFormType(checkFile?.formType)
      loadFileFromS3(checkFile?.fileUrl)
    }
  }

  const handleEventChange = (eventId, timePointUniqueId) => {

    let checkEvent = eventList?.find(item => `${item.eventId}${item.row.TIMEPOINTUNIQUEID || ""}` === `${eventId}${timePointUniqueId || ""}`)
    if (checkEvent) {
      setEventId(eventId)
      setEventName(checkEvent?.row?.EVENTID)
      setTimePointUniqueId(timePointUniqueId || "")
      setTimePointId(checkEvent?.row?.TIMEPOINTID || "")
    }
  }

  const getSourceValue = (columnName, row = sourceData?.[0]) => {
    if (!columnName || !row) return "";
    return row[columnName] ?? "";
  };

  const getDataEntryTypeLabel = (value) => {
    const map = {
      initiateForm: 'Initiate Form',
      eventForm: 'Event Form',
      unScheduledForm: 'Unscheduled Form',
      specialForm: 'Special Form',
    };
    return map[value] || value || '';
  };

  const getFormTypeLabel = (value) => {
    const normalized = String(value || '').toLowerCase();
    const map = {
      log: 'Log Form',
      regular: 'Regular Form',
    };
    return map[normalized] || value || '';
  };

  const getPreviewContextValue = (type, value) => {
    if (!value) return '';

    if (type === 'dataEntryType') {
      return getDataEntryTypeLabel(value);
    }

    if (type === 'form') {
      const selectedForm = fileList?.find((item) => item?.formId === value);
      return selectedForm?.formName || selectedForm?.fileName || value;
    }

    if (type === 'formType') {
      return getFormTypeLabel(value);
    }

    if (type === 'siteId') {
      const selectedSite = siteList?.find((item) => item?.siteId === value);
      return selectedSite?.row?.SITEID || selectedSite?.siteName || value;
    }

    if (type === 'subjectId') {
      const selectedSubject = subjectList?.find((item) => item?.subjectId === value);
      return selectedSubject?.subjectName || selectedSubject?.row?.SCREENID || selectedSubject?.row?.SCREENIND || selectedSubject?.row?.RANDOMNUMBER || selectedSubject?.row?.SUBJECTID || value;
    }

    if (type === 'eventId') {
      const selectedEvent = eventList?.find((item) => item?.eventId === value);
      return selectedEvent?.row?.EVENTID || selectedEvent?.eventName || value;
    }

    if (type === 'timePointUniqueId') {
      const selectedEvent = eventList?.find((item) => item?.row?.TIMEPOINTUNIQUEID === value || item?.row?.TIMEPOINTID === value);
      return selectedEvent?.row?.TIMEPOINTID || selectedEvent?.row?.TIMEPOINTUNIQUEID || value;
    }

    return value;
  };

  const getFieldPreviewColumns = (field) => {
    const storedMappings = columnMappings?.fields?.[field?.id] || {};

    if (field?.type === "date") {
      return [
        storedMappings?.dateColumn,
        storedMappings?.dayColumn,
        storedMappings?.monthColumn,
        storedMappings?.yearColumn,
      ].filter(Boolean);
    }

    if (field?.type === "time") {
      return [
        storedMappings?.timeColumn,
        storedMappings?.hourColumn,
        storedMappings?.minuteColumn,
        storedMappings?.secondColumn,
      ].filter(Boolean);
    }

    if (field?.fieldUnit === "yes") {
      return [
        storedMappings?.unitAndFieldColumn,
        storedMappings?.fieldValueColumn,
        storedMappings?.unitColumn,
      ].filter(Boolean);
    }

    if (field?.customField === "yes") {
      return [
        storedMappings?.fieldValueColumn,
        storedMappings?.unitAndFieldColumn,
        storedMappings?.mappingColumn,
      ].filter(Boolean);
    }

    return [
      storedMappings?.mappingColumn,
      storedMappings?.fieldValueColumn,
    ].filter(Boolean);
  };

  const getPreviewSampleValue = (mappedColumns = [], row = sourceData?.[0]) => {
    if (!mappedColumns?.length) return "";
    const values = mappedColumns
      .map((column) => getSourceValue(column, row))
      .filter((value) => value !== undefined && value !== null && value !== "");

    return values.join(' / ');
  };

  const buildComplexFieldRows = (field) => {
    const mappings = columnMappings?.fields?.[field?.id] || {};
    const allFields = Array.isArray(formFieldList) ? formFieldList : [];

    const linkedByReference = allFields.find((candidate) => {
      if (candidate?.customField !== 'yes') return false;
      const conditionalFields = Array.isArray(candidate?.conditionalFields)
        ? candidate.conditionalFields
        : [];
      return conditionalFields.some((ref) => String(ref || '').startsWith(`${field?.id}_`));
    });

    const linkedCustomParent = linkedByReference || null;

    const parentMeta = {
      parentFieldId: linkedCustomParent?.id || field?.id,
      parentFieldName: linkedCustomParent?.fieldName || field?.fieldName || "",
      parentCustomField: linkedCustomParent?.customField || field?.customField || "no",
    };

    if (field?.type === 'date') {
      const dateParts = [
        { kind: 'dateColumn', label: 'Date', name: field?.fieldName, column: mappings?.dateColumn },
        { kind: 'dayColumn', label: field?.dayLabel || 'Day', name: field?.dayName || field?.fieldName, column: mappings?.dayColumn },
        { kind: 'monthColumn', label: field?.monthLabel || 'Month', name: field?.monthName || field?.fieldName, column: mappings?.monthColumn },
        { kind: 'yearColumn', label: field?.yearLabel || 'Year', name: field?.yearName || field?.fieldName, column: mappings?.yearColumn },
      ];

      return dateParts
        .filter((part) => part.column)
        .map((part) => ({
          kind: 'field',
          id: `${field?.id}-${part.kind}`,
          fieldLabel: `${field?.fieldLabel || ''} / ${part.label}`,
          fieldName: part.name || part.label,
          customField: field?.customField || 'no',
          ...parentMeta,
          mappedColumns: [part.column],
          sampleValue: getPreviewSampleValue([part.column]),
        }));
    }

    if (field?.type === 'time') {
      const timeParts = [
        { kind: 'timeColumn', label: 'Time', name: field?.fieldName, column: mappings?.timeColumn },
        { kind: 'hourColumn', label: field?.hourLabel || 'Hour', name: field?.hourName || field?.fieldName, column: mappings?.hourColumn },
        { kind: 'minuteColumn', label: field?.minuteLabel || 'Minute', name: field?.minuteName || field?.fieldName, column: mappings?.minuteColumn },
        { kind: 'secondColumn', label: field?.secondLabel || 'Second', name: field?.secondName || field?.fieldName, column: mappings?.secondColumn },
      ];

      return timeParts
        .filter((part) => part.column)
        .map((part) => ({
          kind: 'field',
          id: `${field?.id}-${part.kind}`,
          fieldLabel: `${field?.fieldLabel || ''} / ${part.label}`,
          fieldName: part.name || part.label,
          customField: field?.customField || 'no',
          ...parentMeta,
          mappedColumns: [part.column],
          sampleValue: getPreviewSampleValue([part.column]),
        }));
    }

    const customKeys = [
      'referenceRangeLowerLimit',
      'referenceRangeUpperLimit',
      'referenceRangeIndicator',
      'clinicalSignificance',
      'customRemark'
    ];

    const hasCustomPreviewShape = Boolean(
      field?.customField === 'yes' ||
      field?.customField === 'group' ||
      customKeys.some((key) => field?.[key] === 'yes' || Boolean(mappings?.[key]))
    );

    const buildCustomFieldRows = () => {
      const subRows = [];

      const mainColumns = getFieldPreviewColumns(field);
      if (mainColumns?.length) {
        subRows.push({
          kind: 'field',
          id: `${field?.id}-value`,
          fieldLabel: `${field?.fieldLabel || ''} Value`,
          fieldName: field?.fieldName || '',
          customField: 'yes',
          ...parentMeta,
          mappedColumns: mainColumns,
          sampleValue: getPreviewSampleValue(mainColumns),
        });
      }

      const subFieldDefinitions = [
        {
          key: 'referenceRangeLowerLimit',
          label: field?.referenceRangeLowerLimitLabel || 'Reference Range Lower Limit',
          name: field?.referenceRangeLowerLimitName,
          column: mappings?.referenceRangeLowerLimit,
          flag: field?.referenceRangeLowerLimit,
        },
        {
          key: 'referenceRangeUpperLimit',
          label: field?.referenceRangeUpperLimitLabel || 'Reference Range Upper Limit',
          name: field?.referenceRangeUpperLimitName,
          column: mappings?.referenceRangeUpperLimit,
          flag: field?.referenceRangeUpperLimit,
        },
        {
          key: 'referenceRangeIndicator',
          label: field?.referenceRangeIndicatorLabel || 'Reference Range Indicator',
          name: field?.referenceRangeIndicatorName,
          column: mappings?.referenceRangeIndicator,
          flag: field?.referenceRangeIndicator,
        },
        {
          key: 'clinicalSignificance',
          label: field?.clinicalSignificanceLabel || 'Clinical Significance',
          name: field?.clinicalSignificanceName,
          column: mappings?.clinicalSignificance,
          flag: field?.clinicalSignificance,
        },
        {
          key: 'customRemark',
          label: field?.customRemarkLabel || 'Custom Remark',
          name: field?.customRemarkName,
          column: mappings?.customRemark,
          flag: field?.customRemark,
        },
      ];

      subFieldDefinitions.forEach((def) => {
        const selectedColumn = def?.column || '';
        const isEnabledByCfg = def?.flag === 'yes' || Boolean(selectedColumn);

        if (isEnabledByCfg && selectedColumn) {
          subRows.push({
            kind: 'field',
            id: `${field?.id}-${def.key}`,
            fieldLabel: `${field?.fieldLabel || ''} / ${def.label}`,
            fieldName: def.name || def.label,
            customField: 'yes',
            ...parentMeta,
            mappedColumns: [selectedColumn],
            sampleValue: getPreviewSampleValue([selectedColumn]),
          });
        }
      });

      return subRows;
    };

    if (field?.fieldUnit === 'yes') {
      const unitRows = [];

      const hasCombinedUnitColumn = Boolean(mappings?.unitAndFieldColumn);
      const hasSeparateUnitColumns = Boolean(mappings?.fieldValueColumn || mappings?.unitColumn);

      if (hasCombinedUnitColumn && !hasSeparateUnitColumns) {
        unitRows.push({
          kind: 'field',
          id: `${field?.id}-unitAndFieldColumn`,
          fieldLabel: field?.fieldUnitLabel || field?.fieldUnitName || 'Unit + Value',
          fieldName: field?.fieldUnitName || field?.fieldUnitLabel || 'UNIT',
          customField: 'group',
          ...parentMeta,
          mappedColumns: [mappings.unitAndFieldColumn],
          sampleValue: getPreviewSampleValue([mappings.unitAndFieldColumn]),
        });
      }

      if (mappings?.fieldValueColumn) {
        unitRows.push({
          kind: 'field',
          id: `${field?.id}-fieldValueColumn`,
          fieldLabel: field?.fieldLabel || 'Field Value',
          fieldName: field?.fieldName || field?.fieldLabel || '',
          customField: 'group',
          ...parentMeta,
          mappedColumns: [mappings.fieldValueColumn],
          sampleValue: getPreviewSampleValue([mappings.fieldValueColumn]),
        });
      }

      if (mappings?.unitColumn) {
        unitRows.push({
          kind: 'field',
          id: `${field?.id}-unitColumn`,
          fieldLabel: field?.fieldUnitLabel || field?.fieldUnitName || 'Unit',
          fieldName: field?.fieldUnitName || field?.fieldUnitLabel || 'UNIT',
          customField: 'group',
          ...parentMeta,
          mappedColumns: [mappings.unitColumn],
          sampleValue: getPreviewSampleValue([mappings.unitColumn]),
        });
      }

      if (hasCustomPreviewShape) {
        return [...unitRows, ...buildCustomFieldRows()];
      }

      return unitRows;
    }

    if (hasCustomPreviewShape) {
      return buildCustomFieldRows();
    }

    return [{
      kind: 'field',
      id: field?.id,
      fieldLabel: field?.fieldLabel || "",
      fieldName: field?.fieldName || "",
      customField: field?.customField || "no",
      ...parentMeta,
      mappedColumns: getFieldPreviewColumns(field),
      sampleValue: getPreviewSampleValue(getFieldPreviewColumns(field)),
    }];
  };

  const getContextPreviewSampleValue = (type) => {
    if (type === 'studyId') return studyLabel || '_';
    if (type === 'siteId') {
      const mappedColumn = columnMappings?.metadata?.siteId || siteId || '';
      const currentValue = getSourceValue(mappedColumn);
      if (currentValue !== undefined && currentValue !== null && currentValue !== '') return currentValue;

      const value = getPreviewContextValue('siteId', mappedColumn) || '';
      if (value && value !== mappedColumn) return value;
      return '_';
    }
    if (type === 'subjectId') {
      const mappedColumn = columnMappings?.metadata?.subjectId || subjectId || '';
      const currentValue = getSourceValue(mappedColumn);
      if (currentValue !== undefined && currentValue !== null && currentValue !== '') return currentValue;

      if (subjectLabel) return subjectLabel;

      const value = getPreviewContextValue('subjectId', mappedColumn) || '';
      if (value && value !== mappedColumn) return value;

      const selectedSubject = subjectList?.find((item) => item?.subjectId === subjectId);
      const selectedSubjectValue =
        selectedSubject?.subjectName ||
        selectedSubject?.row?.SCREENID ||
        selectedSubject?.row?.SCREENIND ||
        selectedSubject?.row?.RANDOMNUMBER ||
        selectedSubject?.row?.SUBJECTID ||
        selectedSubject?.subjectId ||
        '';
      if (selectedSubjectValue) return selectedSubjectValue;

      return '_';
    }
    if (type === 'eventId') {
      const mappedColumn = columnMappings?.metadata?.eventId || eventId || '';
      const currentValue = getSourceValue(mappedColumn);
      if (currentValue !== undefined && currentValue !== null && currentValue !== '') return currentValue;

      const value = getPreviewContextValue('eventId', mappedColumn) || '';
      if (value && value !== mappedColumn) return value;
      return '_';
    }
    if (type === 'timePointUniqueId') {
      if (level === 'event' && timePointId) {
        return timePointId;
      }

      const mappedColumn = columnMappings?.metadata?.timePointId || timePointUniqueId || '';
      const currentValue = getSourceValue(mappedColumn);
      if (currentValue !== undefined && currentValue !== null && currentValue !== '') return currentValue;
      const value = getPreviewContextValue('timePointUniqueId', mappedColumn) || '';
      if (value && value !== mappedColumn) {
        return value;
      }
      return '_';
    }
    if (type === 'eventRepeat') {
      const mappedColumn = columnMappings?.metadata?.eventRepeat || eventRepeat || '';
      if (!mappedColumn) return '0';
      const value = getSourceValue(mappedColumn) || getPreviewContextValue('eventRepeat', mappedColumn);
      return value || '0';
    }
    if (type === 'dataEntryType') {
      const value = getPreviewContextValue('dataEntryType', dataEntryType || '');
      return value || '_';
    }
    if (type === 'form') {
      const value = getPreviewContextValue('form', formId || fileId || '');
      return value || '_';
    }
    if (type === 'formVersion') return formVersion || '_';
    if (type === 'formType') {
      const value = getPreviewContextValue('formType', formType || '');
      return value || '_';
    }
    if (type === 'formRepeat') {
      const mappedColumn = formRepeat || '';
      if (!mappedColumn) return '0';
      const value = getSourceValue(mappedColumn) || getPreviewContextValue('formRepeat', mappedColumn);
      return value || '0';
    }
    return '_';
  };

  const getContextMappedColumn = (type) => {
    const staticMappedFieldsByLevel = {
      site: ['siteId'],
      subject: ['siteId', 'subjectId'],
      event: ['siteId', 'subjectId', 'eventId', 'timePointUniqueId'],
    };

    const isDynamicField = staticMappedFieldsByLevel[level]?.includes(type);
    if (isDynamicField) {
      return 'DYNAMIC';
    }

    if (type === 'siteId') {
      return columnMappings?.metadata?.siteId || siteId || '';
    }

    if (type === 'subjectId') {
      return columnMappings?.metadata?.subjectId || subjectId || '';
    }

    if (type === 'eventId') {
      return columnMappings?.metadata?.eventId || eventId || '';
    }

    if (type === 'timePointUniqueId') {
      return columnMappings?.metadata?.timePointId || timePointUniqueId || '';
    }

    if (type === 'eventRepeat') {
      return columnMappings?.metadata?.eventRepeat || eventRepeat || 'DEFAULT';
    }

    if (type === 'formRepeat') {
      return formRepeat || 'DEFAULT';
    }

    return '';
  };

  const handleRunPreview = () => {
    const isTimePointOptionalForSpecialForm = level === 'event' && eventId === 'specialForm';

    const getRequiredContextValue = (fieldKey) => {
      if (fieldKey === 'siteId') {
        return columnMappings?.metadata?.siteId || siteId;
      }

      if (fieldKey === 'subjectId') {
        return columnMappings?.metadata?.subjectId || subjectId;
      }

      if (fieldKey === 'eventId') {
        return columnMappings?.metadata?.eventId || eventId;
      }

      if (fieldKey === 'timePointUniqueId') {
        if (isTimePointOptionalForSpecialForm) {
          return 'specialForm';
        }
        return columnMappings?.metadata?.timePointId || timePointUniqueId;
      }

      if (fieldKey === 'eventRepeat') {
        return columnMappings?.metadata?.eventRepeat || eventRepeat;
      }

      if (fieldKey === 'formRepeat') {
        return columnMappings?.metadata?.formRepeat || formRepeat;
      }

      return null;
    };

    const requiredContextFields = [
      { key: 'datasetType', label: 'Dataset Type', value: datasetType },
      { key: 'level', label: 'Level', value: level },
      { key: 'dataEntryType', label: 'Data Entry Type', value: dataEntryType },
      { key: 'studyId', label: 'Study ID', value: studyLabel },
      { key: 'form', label: 'Form', value: fileId || formId },
      { key: 'formVersion', label: 'Form Version', value: formVersion },
      { key: 'formType', label: 'Form Type', value: formType },
      { key: 'siteId', label: 'Site ID', value: getRequiredContextValue('siteId') },
      { key: 'subjectId', label: 'Subject ID', value: getRequiredContextValue('subjectId') },
      { key: 'eventId', label: 'Event ID', value: getRequiredContextValue('eventId') },
    ];

    const missingFields = requiredContextFields.filter((field) => !field.value || String(field.value).trim() === '');

    if (missingFields.length) {
      const missingLabels = missingFields.map((field) => field.label).join(', ');
      const message = `Please select a value for required field(s): ${missingLabels}`;
      setError(message);
      setShowPreview(false);
      window.alert(message);
      return;
    }

    const formRows = normalizedFormFieldList.flatMap((field) => buildComplexFieldRows(field));

    const contextRows = [
      {
        kind: 'context',
        id: 'studyId',
        fieldLabel: 'Study ID',
        fieldName: 'STUDYID',
        mappedColumns: ['DYNAMIC'],
        sampleValue: getContextPreviewSampleValue('studyId'),
      },
      {
        kind: 'context',
        id: 'siteId',
        fieldLabel: 'Site ID',
        fieldName: 'SITEID',
        mappedColumns: [getContextMappedColumn('siteId')].filter(Boolean),
        sampleValue: getContextPreviewSampleValue('siteId'),
      },
      {
        kind: 'context',
        id: 'subjectId',
        fieldLabel: 'Subject ID',
        fieldName: 'SUBJECTID',
        mappedColumns: [getContextMappedColumn('subjectId')].filter(Boolean),
        sampleValue: getContextPreviewSampleValue('subjectId'),
      },
      {
        kind: 'context',
        id: 'eventId',
        fieldLabel: 'Event ID',
        fieldName: 'EVENTID',
        mappedColumns: [getContextMappedColumn('eventId')].filter(Boolean),
        sampleValue: getContextPreviewSampleValue('eventId'),
      },
      {
        kind: 'context',
        id: 'timePointUniqueId',
        fieldLabel: 'TimePoint ID',
        fieldName: 'TIMEPOINTUNIQUEID',
        mappedColumns: [getContextMappedColumn('timePointUniqueId')].filter(Boolean),
        sampleValue: getContextPreviewSampleValue('timePointUniqueId'),
      },
      {
        kind: 'context',
        id: 'eventRepeat',
        fieldLabel: 'Event Repeat',
        fieldName: 'EVENTREPEAT',
        mappedColumns: [getContextMappedColumn('eventRepeat')].filter(Boolean),
        sampleValue: getContextPreviewSampleValue('eventRepeat'),
      }, {
        kind: 'context',
        id: 'dataEntryType',
        fieldLabel: 'Data Entry Type',
        fieldName: 'DATAENTRYTYPE',
        mappedColumns: ['DATAENTRYTYPE'],
        sampleValue: getContextPreviewSampleValue('dataEntryType'),
      },
      {
        kind: 'context',
        id: 'form',
        fieldLabel: 'Form',
        fieldName: 'FORMID',
        mappedColumns: ['FORMID'],
        sampleValue: getContextPreviewSampleValue('form'),
      },
      {
        kind: 'context',
        id: 'formVersion',
        fieldLabel: 'Form Version',
        fieldName: 'FORMVERSION',
        mappedColumns: ['FORMVERSION'],
        sampleValue: getContextPreviewSampleValue('formVersion'),
      },
      {
        kind: 'context',
        id: 'formType',
        fieldLabel: 'Form Type',
        fieldName: 'FORMTYPE',
        mappedColumns: ['FORMTYPE'],
        sampleValue: getContextPreviewSampleValue('formType'),
      },
      {
        kind: 'context',
        id: 'formRepeat',
        fieldLabel: 'Form Repeat',
        fieldName: 'FORMREPEAT',
        mappedColumns: [getContextMappedColumn('formRepeat')].filter(Boolean),
        sampleValue: getContextPreviewSampleValue('formRepeat'),
      }
    ];

    setPreviewData([...contextRows, ...formRows]);
    setShowPreview(true);
    setError("");
  };

  const groupedFormFields = Object.values(
    normalizedFormFieldList.reduce((acc, item) => {

      const groupKey =
        item?.customField === "yes"
          ? "customFields"
          : `field_${item?.id}`;

      if (!acc[groupKey]) {
        acc[groupKey] = {
          groupKey,
          isCustomGroup: item?.customField === "yes",
          fields: []
        };
      }

      acc[groupKey].fields.push(item);

      return acc;
    }, {})
  );

  const CustomMappingRow = ({ fieldId, mappingType, label, name }) => {
    const selectedValue = columnMappings?.fields?.[fieldId]?.[mappingType] || "";

    return (
      <div
        className="maprow mt-2"
        style={{
          display: "grid",
          gridTemplateColumns: "180px 1fr",
          gap: "12px",
          alignItems: "center"
        }}
      >
        <div
          style={{
            fontWeight: 600,
            fontSize: "13px"
          }}
        >
          {label}

          <em
            style={{
              display: "block",
              fontStyle: "normal",
              fontWeight: 400,
              fontSize: "11px",
              color: "#5B6B7C"
            }}
          >
            {name}
          </em>
        </div>

        <div>
          <Form.Select
            style={{
              width: "100%",
              border: "1px solid #DCE3EC",
              borderRadius: "9px",
              padding: "8px 10px"
            }}
            disabled={columns?.length == 0}
            value={selectedValue}
            onChange={(e) => setFieldMapping(fieldId, mappingType, e.target.value)}
          >
            <option value="">
              Select {label} Column
            </option>
            {columns?.map((col, index) => (
              <option key={index} value={col}>{col}</option>
            ))}
          </Form.Select>
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (level === "site" || level === "subject" || level === "event") {
      getStudySiteBasedonAccess()
    }
    setSiteId("");
    setSubjectId("");
    setSubjectLabel("");
    setSchemaId("");
    setEventId("");
    setTimePointUniqueId("");
    setEventName("");
    setTimePointId("");
    setEventRepeat("");
  }, [level]);

  useEffect(() => {
    findStudyLabel();
  }, [studyId]);
  
  useEffect(() => {
    if(datasetType){
      getStudyLabManagementData();
    }
  }, [studyId, datasetType]);

  useEffect(() => {
    setFileId("");
    setFileUniqueId("");
    setFormId("");
    setFormVersion("");
    setFormType("");
    setColumns([]);
    setSourceData([]);
    setPreviewData([]);
    if (studyId) {
      getStudyLabManagementData();
    }
  }, [datasetType]);

  useEffect(() => {
    if (schemaId && level === "event") {
      getEventBasedonSchema()
    }
  }, [schemaId, level]);

  useEffect(() => {
    if (siteId && (level === "subject" || level === "event")) {
      getStudySubjectRowData()
    }
  }, [siteId, level]);

  useEffect(() => {
    if ((level === "site" || level === "subject") && subjectId) {
      setEventId("");
      setTimePointUniqueId("");
      setTimePointId("");
    }
  }, [level, subjectId]);

  return (

    <div
      style={{
        background: '#FFF',
        marginBottom: '20px'
      }}>
      <div className="card-h hsatck justify-content-between" style={{
        height: '42px',
        borderBottom: '1px solid #E9EEF4',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        background: '#F8FAFC'
      }}>
        <div className="px-3 d-flex align-items-center gap-2">
          <div style={{ width: '8px', height: '8px', borderRadius: '50%', background: '#14532d' }} />
          <h2 className='' style={{
            fontWeight: 700,
            fontSize: '15px',
            margin: 0,
            color: '#16334A'
          }}>Galax Data Column Mapping</h2>
        </div>
        <div className="d-flex align-items-center gap-2 px-3">
          <span className="badge bg-light text-dark border" style={{ fontSize: 11 }}>
            {dataLoading ? 'Loading File...' : fileId ? 'Form Loaded' : 'No Form Selected'}
          </span>
          <span className="badge bg-light text-dark border" style={{ fontSize: 11 }}>
            {columns?.length || 0} columns
          </span>
          <button
            className={`updateProfile`}
            style={{ fontSize: 12 }}
            onClick={handleRunPreview}
          >
            Run Preview
          </button>
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={"100%"}
      >
        <div className="card-b" style={{ padding: '20px' }}>

          {error && (
            <div className="alert alert-danger py-2 small mb-3">
              {error}
            </div>
          )}

          <div className="mb-3" style={{
            border: '1px solid #E9EEF4',
            background: '#F8FAFC',
            borderRadius: '10px',
            padding: '12px'
          }}>
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <div>
                <div style={{ fontSize: 11, color: '#64748B', textTransform: 'uppercase', letterSpacing: '0.8px' }}>
                  Mapping Context
                </div>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#16334A' }}>
                  {studyLabel}
                  {datasetType ? <span className='text-capitalize'>{` / ${datasetType} Dataset`}</span> : ''}
                  {level ? <span className='text-capitalize'>{` / ${level} Level`}</span> : ''}
                </div>
              </div>
              <div className="d-flex gap-2">
                <span className="badge bg-white border border-secondary-subtle text-dark" style={{ fontSize: 11 }}>
                  Data Entry: {dataEntryType === "initiateForm" ? "Initiate Form" : dataEntryType === "eventForm" ? "Event Form" : dataEntryType === "specialForm" ? "Special Form" : "Not Selected"}
                </span>
                <span className="badge bg-white border border-secondary-subtle text-dark" style={{ fontSize: 11 }}>
                  Source Rows: {sourceData?.length || 0}
                </span>
              </div>
            </div>
          </div>

          <div id="colmap">

            <div
              className="maprow"
              style={{
                display: "grid",
                gridTemplateColumns: "180px 1fr 1fr",
                gap: "12px",
                alignItems: "center",
                padding: "9px 0",
                borderBottom: "1px solid #E9EEF4",
              }}
            >
              <div
                className="canon"
                style={{
                  fontWeight: 600,
                  fontSize: "13px",
                }}
              >
                Dataset Type
                <span
                  style={{
                    color: "#DC2626",
                    fontSize: "10px",
                    marginLeft: "4px",
                  }}
                >
                  required
                </span>
              </div>

              <div>
                <Form.Select
                  style={{
                    width: "100%",
                    border: "1px solid #DCE3EC",
                    borderRadius: "9px",
                    padding: "8px 10px",
                    background: "#fff",
                    color: "#0E2A47",
                    fontSize: "13px",
                  }}
                  onChange={(e) => setDatasetType(e.target.value)}
                  value={datasetType}
                >
                  <option value="">Select Dataset Type</option>
                  <option value="row">Row Dataset</option>
                  <option value="column">Column Dataset</option>
                </Form.Select>
              </div>
            </div>
            <div
              className="maprow"
              style={{
                display: "grid",
                gridTemplateColumns: "180px 1fr 1fr",
                gap: "12px",
                alignItems: "center",
                padding: "9px 0",
                borderBottom: "1px solid #E9EEF4",
              }}
            >
              <div
                className="canon"
                style={{
                  fontWeight: 600,
                  fontSize: "13px",
                }}
              >
                Data Entry Type
                <span
                  style={{
                    color: "#DC2626",
                    fontSize: "10px",
                    marginLeft: "4px",
                  }}
                >
                  required
                </span>

                <em
                  style={{
                    display: "block",
                    fontStyle: "normal",
                    fontWeight: 400,
                    fontSize: "11px",
                    color: "#5B6B7C",
                  }}
                >
                  DATAENTRYTYPE
                </em>
              </div>

              <div>
                <Form.Select
                  style={{
                    width: "100%",
                    border: "1px solid #DCE3EC",
                    borderRadius: "9px",
                    padding: "8px 10px",
                    background: "#fff",
                    color: "#0E2A47",
                    fontSize: "13px",
                  }}
                  onChange={(e) => setDataEntryType(e.target.value)}
                  value={dataEntryType}
                >
                  <option value="">Select Data Entry Type</option>
                  <option value="initiateForm">Initiate Form</option>
                  <option value="eventForm">Event form</option>
                  <option value="unScheduledForm">Unscheduled form</option>
                  <option value="specialForm">Special Form</option>
                </Form.Select>
              </div>
            </div>
            {datasetType &&
              <div
                className="maprow"
                style={{
                  display: "grid",
                  gridTemplateColumns: "180px 1fr 1fr",
                  gap: "12px",
                  alignItems: "center",
                  padding: "9px 0",
                  borderBottom: "1px solid #E9EEF4",
                }}
              >
                <div
                  className="canon"
                  style={{
                    fontWeight: 600,
                    fontSize: "13px",
                  }}
                >
                  Form
                  <span
                    style={{
                      color: "#DC2626",
                      fontSize: "10px",
                      marginLeft: "4px",
                    }}
                  >
                    required
                  </span>

                  <em
                    style={{
                      display: "block",
                      fontStyle: "normal",
                      fontWeight: 400,
                      fontSize: "11px",
                      color: "#5B6B7C",
                    }}
                  >
                    FORMID, VERSION & FORMTYPE
                  </em>
                </div>

                <div>
                  {fileLoader ?
                    <div className='fw-bold' style={{ fontSize: 13 }}><Spinner style={{ height: 10, width: 10 }} /> Form Loading...</div>
                    :
                    <>
                      <Form.Select
                        style={{
                          width: "100%",
                          border: "1px solid #DCE3EC",
                          borderRadius: "9px",
                          padding: "8px 10px",
                          background: "#fff",
                          color: "#0E2A47",
                          fontSize: "13px",
                        }}
                        onChange={(e) => handleFileChange(e.target.value)}
                        value={fileId}
                      >
                        <option value="">{datasetType ? "Select Form" : "Select Dataset Type First"}</option>
                        {filteredFileList?.map((item, index) => (
                          <option key={index} value={item?.fileId}>{item?.fileName}</option>
                        ))}
                      </Form.Select>
                      {fileId &&
                        <em
                          style={{
                            display: "block",
                            fontStyle: "normal",
                            fontWeight: 400,
                            fontSize: "11px",
                            color: "#5B6B7C",
                          }}
                        >
                          <b>VERSION:</b> {formVersion}, <b>FORMTYPE:</b> {formType === "log" ? "Log" : "Regular"} Form
                        </em>
                      }
                    </>
                  }
                </div>
              </div>
            }
            {formId &&
              <>
                <div
                  className="maprow"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "180px 1fr 1fr",
                    gap: "12px",
                    alignItems: "center",
                    padding: "9px 0",
                    borderBottom: "1px solid #E9EEF4",
                  }}
                >
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: "13px",
                    }}
                  >
                    Form Repeat
                    <em
                      style={{
                        display: "block",
                        fontStyle: "normal",
                        fontWeight: 400,
                        fontSize: "11px",
                        color: "#5B6B7C",
                      }}
                    >
                      FORMREPEAT
                    </em>
                  </div>
                  <div>
                    <Form.Select
                      style={{
                        width: "100%",
                        border: "1px solid #DCE3EC",
                        borderRadius: "9px",
                        padding: "8px 10px",
                        background: "#fff",
                        color: "#0E2A47",
                        fontSize: "13px",
                      }}
                      disabled={columns?.length == 0}
                      onChange={(e) => {
                        setFormRepeat(e.target.value)
                        setMetadataMapping('formRepeat', e.target.value)
                      }}
                      value={formRepeat}
                    >
                      <option value="">Select Form Repeat Column</option>
                      {columns?.map((col, index) => (
                        <option key={index} value={col}>{col}</option>
                      ))}
                    </Form.Select>
                    <em
                      style={{
                        display: "block",
                        fontStyle: "normal",
                        fontWeight: 400,
                        fontSize: "11px",
                        color: "#5B6B7C",
                      }}
                    >
                      <b>Note:</b> If Form Repeat is not selected, the default value should be considered 0.
                    </em>
                  </div>
                </div>
                <div
                  className="maprow"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "180px 1fr 1fr",
                    gap: "12px",
                    alignItems: "center",
                    padding: "9px 0",
                    borderBottom: "1px solid #E9EEF4",
                  }}
                >
                  <div
                    className="canon"
                    style={{
                      fontWeight: 600,
                      fontSize: "13px",
                    }}
                  >
                    Level
                    <span
                      style={{
                        color: "#DC2626",
                        fontSize: "10px",
                        marginLeft: "4px",
                      }}
                    >
                      required
                    </span>
                  </div>

                  <div>
                    <Form.Select
                      style={{
                        width: "100%",
                        border: "1px solid #DCE3EC",
                        borderRadius: "9px",
                        padding: "8px 10px",
                        background: "#fff",
                        color: "#0E2A47",
                        fontSize: "13px",
                      }}
                      onChange={(e) => setLevel(e.target.value)}
                      value={level}
                    >
                      <option value="">Select Level</option>
                      <option value="study">Study Level</option>
                      <option value="site">Site Level</option>
                      <option value="subject">Subject Level</option>
                      <option value="event">Event Level</option>
                    </Form.Select>
                  </div>
                </div>
              </>
            }
            {level &&
              <div
                className="maprow"
                style={{
                  display: "grid",
                  gridTemplateColumns: "180px 1fr 1fr",
                  gap: "12px",
                  alignItems: "center",
                  padding: "9px 0",
                  borderBottom: "1px solid #E9EEF4",
                }}
              >
                <div
                  className="canon"
                  style={{
                    fontWeight: 600,
                    fontSize: "13px",
                  }}
                >
                  StudyId
                  <span
                    style={{
                      color: "#DC2626",
                      fontSize: "10px",
                      marginLeft: "4px",
                    }}
                  >
                    required
                  </span>

                  <em
                    style={{
                      display: "block",
                      fontStyle: "normal",
                      fontWeight: 400,
                      fontSize: "11px",
                      color: "#5B6B7C",
                    }}
                  >
                    STUDYID
                  </em>
                </div>

                <div>
                  <Form.Control
                    style={{
                      width: "100%",
                      border: "1px solid #DCE3EC",
                      borderRadius: "9px",
                      padding: "8px 10px",
                      background: "#fff",
                      color: "#0E2A47",
                      fontSize: "13px",
                    }}
                    value={studyLabel}
                    disabled={siteList?.length === 0}
                  />
                </div>
              </div>
            }
            {showDynamicSite &&
              <div
                className="maprow"
                style={{
                  display: "grid",
                  gridTemplateColumns: "180px 1fr 1fr",
                  gap: "12px",
                  alignItems: "center",
                  padding: "9px 0",
                  borderBottom: "1px solid #E9EEF4",
                }}
              >
                <div
                  className="canon"
                  style={{
                    fontWeight: 600,
                    fontSize: "13px",
                  }}
                >
                  Site
                  <span
                    style={{
                      color: "#DC2626",
                      fontSize: "10px",
                      marginLeft: "4px",
                    }}
                  >
                    required
                  </span>

                  <em
                    style={{
                      display: "block",
                      fontStyle: "normal",
                      fontWeight: 400,
                      fontSize: "11px",
                      color: "#5B6B7C",
                    }}
                  >
                    SITEID
                  </em>
                </div>
                {siteLoader ?
                  <div className='fw-bold' style={{ fontSize: 13 }}><Spinner style={{ height: 10, width: 10 }} /> Site Loading...</div>
                  :
                  <>
                    <div>
                      <Form.Select
                        style={{
                          width: "100%",
                          border: "1px solid #DCE3EC",
                          borderRadius: "9px",
                          padding: "8px 10px",
                          background: "#fff",
                          color: "#0E2A47",
                          fontSize: "13px",
                        }}
                        disabled={siteList?.length === 0}
                        onChange={(e) => setSiteId(e.target.value)}
                        value={siteId}
                      >
                        <option value="">Select Site</option>
                        {siteList.map((item, index) => (
                          <option key={index} value={item.siteId}>
                            {item.row?.SITEID}
                          </option>
                        ))}
                      </Form.Select>
                    </div>
                  </>
                }
              </div>
            }
            {showDynamicSubject &&
              <div
                className="maprow"
                style={{
                  display: "grid",
                  gridTemplateColumns: "180px 1fr 1fr",
                  gap: "12px",
                  alignItems: "center",
                  padding: "9px 0",
                  borderBottom: "1px solid #E9EEF4",
                }}
              >
                <div
                  className="canon"
                  style={{
                    fontWeight: 600,
                    fontSize: "13px",
                  }}
                >
                  Subject
                  <span
                    style={{
                      color: "#DC2626",
                      fontSize: "10px",
                      marginLeft: "4px",
                    }}
                  >
                    required
                  </span>

                  <em
                    style={{
                      display: "block",
                      fontStyle: "normal",
                      fontWeight: 400,
                      fontSize: "11px",
                      color: "#5B6B7C",
                    }}
                  >
                    SUBJECTID
                  </em>
                </div>
                {subjectLoader ?
                  <div className='fw-bold' style={{ fontSize: 13 }}><Spinner style={{ height: 10, width: 10 }} /> Subject Loading...</div>
                  :
                  <>
                    <div>
                      <Form.Select
                        style={{
                          width: "100%",
                          border: "1px solid #DCE3EC",
                          borderRadius: "9px",
                          padding: "8px 10px",
                          background: "#fff",
                          color: "#0E2A47",
                          fontSize: "13px",
                        }}
                        disabled={subjectList?.length === 0}
                        onChange={(e) => {
                          setSubjectId(e.target.value)
                          setSubjectLabel(e.target[e.target.selectedIndex]?.text || "")
                          setSchemaId(e.target[e.target.selectedIndex].id)
                          setMetadataMapping('subjectId', e.target.value)
                        }}
                        value={subjectId}
                      >
                        <option value="">Select Subject</option>
                        {subjectList?.map((item, index) => (
                          <option key={index} value={item?.subjectId} id={item?.schemaId}>{item?.row?.SCREENID || item?.row?.RANDOMNUMBER || item?.row?.SUBJECTID}</option>
                        ))}
                      </Form.Select>
                    </div>
                  </>
                }
              </div>
            }
            {showDynamicEvent &&
              <>
                <div
                  className="maprow"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "180px 1fr 1fr",
                    gap: "12px",
                    alignItems: "center",
                    padding: "9px 0",
                    borderBottom: "1px solid #E9EEF4",
                  }}
                >
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: "13px",
                    }}
                  >
                    Event
                    <span
                      style={{
                        color: "#DC2626",
                        fontSize: "10px",
                        marginLeft: "4px",
                      }}
                    >
                      required
                    </span>

                    <em
                      style={{
                        display: "block",
                        fontStyle: "normal",
                        fontWeight: 400,
                        fontSize: "11px",
                        color: "#5B6B7C",
                      }}
                    >
                      EVENTID & TIMEPOINTID
                    </em>
                  </div>
                  {eventLoader ?
                    <div className='fw-bold' style={{ fontSize: 13 }}><Spinner style={{ height: 10, width: 10 }} /> Event Loading...</div>
                    :
                    <>
                      <div>
                        <Form.Select
                          style={{
                            width: "100%",
                            border: "1px solid #DCE3EC",
                            borderRadius: "9px",
                            padding: "8px 10px",
                          }}
                          disabled={eventList?.length === 0}
                          onChange={(e) => {
                            handleEventChange(e.target.value, e.target[e.target.selectedIndex].id)
                            setMetadataMapping('eventId', e.target.value)
                          }}
                        >
                          <option selected={eventId === ""} value="">Select Event</option>
                          {eventList?.map((item, index) => (
                            <option
                              key={index}
                              selected={
                                `${item.eventId}${item?.row?.["TIMEPOINTUNIQUEID"] || ""
                                }` === `${eventId}${timePointUniqueId || ""}`
                              }
                              value={item?.eventId}
                              id={item?.row?.["TIMEPOINTUNIQUEID"] || ""}
                            >
                              {item?.row?.["EVENTID"]} {item?.row?.["TIMEPOINTUNIQUEID"] && `(${item?.row?.["TIMEPOINTID"]})`}
                            </option>
                          ))}
                          <option selected={eventId === "specialForm"} value="specialForm" id="">Special Form</option>
                        </Form.Select>
                        {timePointId &&
                          <em
                            style={{
                              display: "block",
                              fontStyle: "normal",
                              fontWeight: 400,
                              fontSize: "11px",
                              color: "#5B6B7C",
                            }}
                          >
                            <b>TIMEPOINTID:</b> {timePointId}
                          </em>
                        }
                      </div>
                    </>
                  }
                </div>
              </>
            }
            {showColumnSite &&
              <div
                className="maprow"
                style={{
                  display: "grid",
                  gridTemplateColumns: "180px 1fr 1fr",
                  gap: "12px",
                  alignItems: "center",
                  padding: "9px 0",
                  borderBottom: "1px solid #E9EEF4",
                }}
              >
                <div
                  className="canon"
                  style={{
                    fontWeight: 600,
                    fontSize: "13px",
                  }}
                >
                  Site
                  <span
                    style={{
                      color: "#DC2626",
                      fontSize: "10px",
                      marginLeft: "4px",
                    }}
                  >
                    required
                  </span>

                  <em
                    style={{
                      display: "block",
                      fontStyle: "normal",
                      fontWeight: 400,
                      fontSize: "11px",
                      color: "#5B6B7C",
                    }}
                  >
                    SITEID
                  </em>
                </div>

                <div>
                  <Form.Select
                    style={{
                      width: "100%",
                      border: "1px solid #DCE3EC",
                      borderRadius: "9px",
                      padding: "8px 10px",
                      background: "#fff",
                      color: "#0E2A47",
                      fontSize: "13px",
                    }}
                    disabled={columns?.length == 0}
                    onChange={(e) => {
                      setSiteId(e.target.value)
                      setMetadataMapping('siteId', e.target.value)
                    }}
                    value={siteId}
                  >
                    <option value="">Select Site Column</option>
                    {columns?.map((col, index) => (
                      <option key={index} value={col}>{col}</option>
                    ))}
                  </Form.Select>
                </div>
              </div>
            }
            {showColumnSubject &&
              <>
                {siteId &&
                  <div
                    className="maprow"
                    style={{
                      display: "grid",
                      gridTemplateColumns: "180px 1fr 1fr",
                      gap: "12px",
                      alignItems: "center",
                      padding: "9px 0",
                      borderBottom: "1px solid #E9EEF4",
                    }}
                  >
                    <div
                      className="canon"
                      style={{
                        fontWeight: 600,
                        fontSize: "13px",
                      }}
                    >
                      Subject
                      <span
                        style={{
                          color: "#DC2626",
                          fontSize: "10px",
                          marginLeft: "4px",
                        }}
                      >
                        required
                      </span>

                      <em
                        style={{
                          display: "block",
                          fontStyle: "normal",
                          fontWeight: 400,
                          fontSize: "11px",
                          color: "#5B6B7C",
                        }}
                      >
                        SUBJECTID
                      </em>
                    </div>

                    <div>
                      <Form.Select
                        style={{
                          width: "100%",
                          border: "1px solid #DCE3EC",
                          borderRadius: "9px",
                          padding: "8px 10px",
                          background: "#fff",
                          color: "#0E2A47",
                          fontSize: "13px",
                        }}
                        disabled={columns?.length == 0}
                        onChange={(e) => {
                          setSubjectId(e.target.value)
                          setMetadataMapping('subjectId', e.target.value)
                        }}
                        value={subjectId}
                      >
                        <option value="">Select Subject Column</option>
                        {columns?.map((col, index) => (
                          <option key={index} value={col}>{col}</option>
                        ))}
                      </Form.Select>
                    </div>
                  </div>
                }
              </>
            }
            {shouldShowSubjectEventColumn &&
              <>
                <div
                  className="maprow"
                  style={{
                    display: "grid",
                    gridTemplateColumns: "180px 1fr 1fr",
                    gap: "12px",
                    alignItems: "center",
                    padding: "9px 0",
                    borderBottom: "1px solid #E9EEF4",
                  }}
                >
                  <div
                    style={{
                      fontWeight: 600,
                      fontSize: "13px",
                    }}
                  >
                    Event
                    <span
                      style={{
                        color: "#DC2626",
                        fontSize: "10px",
                        marginLeft: "4px",
                      }}
                    >
                      required
                    </span>

                    <em
                      style={{
                        display: "block",
                        fontStyle: "normal",
                        fontWeight: 400,
                        fontSize: "11px",
                        color: "#5B6B7C",
                      }}
                    >
                      EVENTID
                    </em>
                  </div>

                  <div>
                    <Form.Select
                      style={{
                        width: "100%",
                        border: "1px solid #DCE3EC",
                        borderRadius: "9px",
                        padding: "8px 10px",
                      }}
                      disabled={columns?.length == 0}
                      onChange={(e) => {
                        setEventId(e.target.value)
                        setMetadataMapping('eventId', e.target.value)
                      }}
                      value={eventId}
                    >
                      <option value="">Select Event Column</option>
                      {columns?.map((col, index) => (
                        <option key={index} value={col}>{col}</option>
                      ))}
                    </Form.Select>
                  </div>
                </div>
                {eventId &&
                  <div
                    className="maprow"
                    style={{
                      display: "grid",
                      gridTemplateColumns: "180px 1fr 1fr",
                      gap: "12px",
                      alignItems: "center",
                      padding: "9px 0",
                      borderBottom: "1px solid #E9EEF4",
                    }}
                  >
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: "13px",
                      }}
                    >
                      TimePoint
                      <span
                        style={{
                          color: "#DC2626",
                          fontSize: "10px",
                          marginLeft: "4px",
                        }}
                      >
                        required
                      </span>

                      <em
                        style={{
                          display: "block",
                          fontStyle: "normal",
                          fontWeight: 400,
                          fontSize: "11px",
                          color: "#5B6B7C",
                        }}
                      >
                        TIMEPOINTID
                      </em>
                    </div>

                    <div>
                      <Form.Select
                        style={{
                          width: "100%",
                          border: "1px solid #DCE3EC",
                          borderRadius: "9px",
                          padding: "8px 10px",
                        }}
                        disabled={columns?.length == 0}
                        onChange={(e) => {
                          setTimePointUniqueId(e.target.value)
                          setMetadataMapping('timePointId', e.target.value)
                        }}
                        value={timePointUniqueId}
                      >
                        <option value="">Select TimePoint Column</option>
                        {columns?.map((col, index) => (
                          <option key={index} value={col}>{col}</option>
                        ))}
                      </Form.Select>
                    </div>
                  </div>
                }
              </>
            }
            {eventId &&
              <div
                className="maprow"
                style={{
                  display: "grid",
                  gridTemplateColumns: "180px 1fr 1fr",
                  gap: "12px",
                  alignItems: "center",
                  padding: "9px 0",
                  borderBottom: "1px solid #E9EEF4",
                }}
              >
                <div
                  style={{
                    fontWeight: 600,
                    fontSize: "13px",
                  }}
                >
                  Event Repeat
                  <em
                    style={{
                      display: "block",
                      fontStyle: "normal",
                      fontWeight: 400,
                      fontSize: "11px",
                      color: "#5B6B7C",
                    }}
                  >
                    EVENTREPEAT
                  </em>
                </div>

                <div>
                  <Form.Select
                    style={{
                      width: "100%",
                      border: "1px solid #DCE3EC",
                      borderRadius: "9px",
                      padding: "8px 10px",
                      background: "#fff",
                      color: "#0E2A47",
                      fontSize: "13px",
                    }}
                    disabled={columns?.length == 0}
                    onChange={(e) => setEventRepeat(e.target.value)}
                    value={eventRepeat}
                  >
                    <option value="">Select Event Repeat Column</option>
                    {columns?.map((col, index) => (
                      <option key={index} value={col}>{col}</option>
                    ))}
                  </Form.Select>
                  <em
                    style={{
                      display: "block",
                      fontStyle: "normal",
                      fontWeight: 400,
                      fontSize: "11px",
                      color: "#5B6B7C",
                    }}
                  >
                    <b>Note:</b> If Event Repeat is not selected, the default value should be considered 0.
                  </em>
                </div>
              </div>
            }
            {formFieldLoader ?
              <PageLoader />
              :
              <>
                {dataEntryMessage ?
                  <div
                    className='mt-3 text-danger'
                    style={{
                      fontWeight: 600,
                      fontSize: "13px"
                    }}>{dataEntryMessage}</div>
                  :
                  (level === "site" ? siteId : level === "subject" ? (siteId && subjectId) : level === "event" ? (siteId && subjectId && eventId) : true) && groupedFormFields.map((group) => (
                    <div key={group.groupKey} className="mb-3">
                      {group.isCustomGroup && (
                        <div
                          style={{
                            fontWeight: 600,
                            fontSize: "14px",
                            padding: "10px 12px",
                            background: "#F5F7FA",
                            border: "1px solid #E9EEF4",
                            borderBottom: "none",
                            borderRadius: "8px 8px 0 0"
                          }}
                        >
                          Custom Fields
                        </div>
                      )}
                      {group.fields.map((item) => (
                        <div
                          key={item?.id}
                          className="maprow"
                          style={{
                            padding: "9px 0",
                            borderBottom: "1px solid #E9EEF4"
                          }}
                        >
                          <div
                            style={{
                              display: "grid",
                              gridTemplateColumns: (item?.type === "time" || item?.type === "date" || item?.fieldUnit === "yes") ? "180px 1fr" : "180px 1fr 1fr",
                              gap: "12px",
                              alignItems: "center"
                            }}
                          >

                            <div
                              style={{
                                fontWeight: 600,
                                fontSize: "13px"
                              }}
                            >
                              {isHTMLIdentifier(item?.fieldLabel || "") ? (
                                <span dangerouslySetInnerHTML={{ __html: item?.fieldLabel }} />
                              ) : (
                                item?.fieldLabel
                              )}

                              <em
                                style={{
                                  display: "block",
                                  fontStyle: "normal",
                                  fontWeight: 400,
                                  fontSize: "11px",
                                  color: "#5B6B7C"
                                }}
                              >
                                {item?.fieldName}
                              </em>
                            </div>
                            <div>
                              {item?.type === "date" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "12px",
                                    width: "100%"
                                  }}
                                >
                                  <Form.Select
                                    style={{
                                      flex: 1,
                                      border: "1px solid #DCE3EC",
                                      borderRadius: "9px",
                                      padding: "8px 10px"
                                    }}
                                    disabled={columns?.length == 0}
                                    value={columnMappings?.fields?.[item?.id]?.dateColumn || ""}
                                    onChange={(e) => setFieldMapping(item?.id, 'dateColumn', e.target.value)}
                                  >
                                    <option value="">
                                      Select {isHTMLIdentifier(item?.fieldLabel || "") ? (
                                        <span dangerouslySetInnerHTML={{ __html: item?.fieldLabel }} />
                                      ) : (
                                        item?.fieldLabel
                                      ) || "Date"} Column
                                    </option>
                                    {columns?.map((col, index) => (
                                      <option key={index} value={col}>{col}</option>
                                    ))}
                                  </Form.Select>
                                  <div
                                    style={{
                                      fontWeight: 600,
                                      fontSize: "13px"
                                    }}
                                    className='hstack'
                                  >OR</div>
                                  <Form.Select
                                    style={{
                                      flex: 1,
                                      border: "1px solid #DCE3EC",
                                      borderRadius: "9px",
                                      padding: "8px 10px"
                                    }}
                                    disabled={columns?.length == 0}
                                    value={columnMappings?.fields?.[item?.id]?.dayColumn || ""}
                                    onChange={(e) => setFieldMapping(item?.id, 'dayColumn', e.target.value)}
                                  >
                                    <option value="">
                                      Select {item?.dayLabel || "Day"} Column
                                    </option>
                                    {columns?.map((col, index) => (
                                      <option key={index} value={col}>{col}</option>
                                    ))}
                                  </Form.Select>
                                  <Form.Select
                                    style={{
                                      flex: 1,
                                      border: "1px solid #DCE3EC",
                                      borderRadius: "9px",
                                      padding: "8px 10px"
                                    }}
                                    disabled={columns?.length == 0}
                                    value={columnMappings?.fields?.[item?.id]?.monthColumn || ""}
                                    onChange={(e) => setFieldMapping(item?.id, 'monthColumn', e.target.value)}
                                  >
                                    <option value="">
                                      Select {item?.monthLabel || "Month"} Column
                                    </option>
                                    {columns?.map((col, index) => (
                                      <option key={index} value={col}>{col}</option>
                                    ))}
                                  </Form.Select>
                                  <Form.Select
                                    style={{
                                      flex: 1,
                                      border: "1px solid #DCE3EC",
                                      borderRadius: "9px",
                                      padding: "8px 10px"
                                    }}
                                    disabled={columns?.length == 0}
                                    value={columnMappings?.fields?.[item?.id]?.yearColumn || ""}
                                    onChange={(e) => setFieldMapping(item?.id, 'yearColumn', e.target.value)}
                                  >
                                    <option value="">
                                      Select {item?.yearLabel || "Year"} Column
                                    </option>
                                    {columns?.map((col, index) => (
                                      <option key={index} value={col}>{col}</option>
                                    ))}
                                  </Form.Select>
                                </div>
                              ) : item?.type === "time" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "12px",
                                    width: "100%"
                                  }}
                                >
                                  <Form.Select
                                    style={{
                                      flex: 1,
                                      border: "1px solid #DCE3EC",
                                      borderRadius: "9px",
                                      padding: "8px 10px"
                                    }}
                                    disabled={columns?.length == 0}
                                    value={columnMappings?.fields?.[item?.id]?.timeColumn || ""}
                                    onChange={(e) => setFieldMapping(item?.id, 'timeColumn', e.target.value)}
                                  >
                                    <option value="">
                                      Select {isHTMLIdentifier(item?.fieldLabel || "") ? (
                                        <span dangerouslySetInnerHTML={{ __html: item?.fieldLabel }} />
                                      ) : (
                                        item?.fieldLabel
                                      ) || "Time"} Column
                                    </option>
                                    {columns?.map((col, index) => (
                                      <option key={index} value={col}>{col}</option>
                                    ))}
                                  </Form.Select>
                                  <div
                                    style={{
                                      fontWeight: 600,
                                      fontSize: "13px"
                                    }}
                                    className='hstack'
                                  >OR</div>
                                  <Form.Select
                                    style={{
                                      flex: 1,
                                      border: "1px solid #DCE3EC",
                                      borderRadius: "9px",
                                      padding: "8px 10px"
                                    }}
                                    disabled={columns?.length == 0}
                                    value={columnMappings?.fields?.[item?.id]?.hourColumn || ""}
                                    onChange={(e) => setFieldMapping(item?.id, 'hourColumn', e.target.value)}
                                  >
                                    <option value="">
                                      Select {item?.hourLabel || "Hour"} Column
                                    </option>
                                    {columns?.map((col, index) => (
                                      <option key={index} value={col}>{col}</option>
                                    ))}
                                  </Form.Select>
                                  <Form.Select
                                    style={{
                                      flex: 1,
                                      border: "1px solid #DCE3EC",
                                      borderRadius: "9px",
                                      padding: "8px 10px"
                                    }}
                                    disabled={columns?.length == 0}
                                    value={columnMappings?.fields?.[item?.id]?.minuteColumn || ""}
                                    onChange={(e) => setFieldMapping(item?.id, 'minuteColumn', e.target.value)}
                                  >
                                    <option value="">
                                      Select {item?.minuteLabel || "Minute"} Column
                                    </option>
                                    {columns?.map((col, index) => (
                                      <option key={index} value={col}>{col}</option>
                                    ))}
                                  </Form.Select>
                                  {item?.timeFormat === "hhmmss" &&
                                    <Form.Select
                                      style={{
                                        flex: 1,
                                        border: "1px solid #DCE3EC",
                                        borderRadius: "9px",
                                        padding: "8px 10px"
                                      }}
                                      disabled={columns?.length == 0}
                                      value={columnMappings?.fields?.[item?.id]?.secondColumn || ""}
                                      onChange={(e) => setFieldMapping(item?.id, 'secondColumn', e.target.value)}
                                    >
                                      <option value="">
                                        Select {item?.secondLabel || "Second"} Column
                                      </option>
                                      {columns?.map((col, index) => (
                                        <option key={index} value={col}>{col}</option>
                                      ))}
                                    </Form.Select>
                                  }
                                </div>
                              ) : item?.fieldUnit === "yes" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "12px",
                                    width: "100%"
                                  }}
                                >
                                  {item?.customField === "no" &&
                                    <>
                                      <Form.Select
                                        style={{
                                          width: "100%",
                                          border: "1px solid #DCE3EC",
                                          borderRadius: "9px",
                                          padding: "8px 10px"
                                        }}
                                        disabled={columns?.length == 0}
                                        value={columnMappings?.fields?.[item?.id]?.unitAndFieldColumn || ""}
                                        onChange={(e) => setFieldMapping(item?.id, 'unitAndFieldColumn', e.target.value)}
                                      >
                                        <option value="">
                                          Select {isHTMLIdentifier(item?.fieldLabel || "") ? (
                                            <span dangerouslySetInnerHTML={{ __html: item?.fieldLabel }} />
                                          ) : (
                                            item?.fieldLabel
                                          )} and {item?.fieldUnitLabel} Column
                                        </option>
                                        {columns?.map((col, index) => (
                                          <option key={index} value={col}>{col}</option>
                                        ))}
                                      </Form.Select>
                                      <div
                                        style={{
                                          fontWeight: 600,
                                          fontSize: "13px"
                                        }}
                                        className='hstack'
                                      >OR</div>
                                    </>
                                  }
                                  <Form.Select
                                    style={{
                                      width: "100%",
                                      border: "1px solid #DCE3EC",
                                      borderRadius: "9px",
                                      padding: "8px 10px"
                                    }}
                                    disabled={columns?.length == 0}
                                    value={columnMappings?.fields?.[item?.id]?.fieldValueColumn || ""}
                                    onChange={(e) => setFieldMapping(item?.id, 'fieldValueColumn', e.target.value)}
                                  >
                                    <option value="">
                                      Select {isHTMLIdentifier(item?.fieldLabel || "") ? (
                                        <span dangerouslySetInnerHTML={{ __html: item?.fieldLabel }} />
                                      ) : (
                                        item?.fieldLabel
                                      )} Column
                                    </option>
                                    {columns?.map((col, index) => (
                                      <option key={index} value={col}>{col}</option>
                                    ))}
                                  </Form.Select>
                                  <Form.Select
                                    style={{
                                      width: "100%",
                                      border: "1px solid #DCE3EC",
                                      borderRadius: "9px",
                                      padding: "8px 10px"
                                    }}
                                    disabled={columns?.length == 0}
                                    value={columnMappings?.fields?.[item?.id]?.unitColumn || ""}
                                    onChange={(e) => setFieldMapping(item?.id, 'unitColumn', e.target.value)}
                                  >
                                    <option value="">
                                      Select {item?.fieldUnitLabel} Column
                                    </option>
                                    {columns?.map((col, index) => (
                                      <option key={index} value={col}>{col}</option>
                                    ))}
                                  </Form.Select>
                                </div>
                              ) : (
                                <Form.Select
                                  style={{
                                    width: "100%",
                                    border: "1px solid #DCE3EC",
                                    borderRadius: "9px",
                                    padding: "8px 10px"
                                  }}
                                  disabled={columns?.length == 0}
                                  value={columnMappings?.fields?.[item?.id]?.mappingColumn || ""}
                                  onChange={(e) => setFieldMapping(item?.id, 'mappingColumn', e.target.value)}
                                >
                                  <option value="">
                                    Select {isHTMLIdentifier(item?.fieldLabel || "") ? (
                                      <span dangerouslySetInnerHTML={{ __html: item?.fieldLabel }} />
                                    ) : (
                                      item?.fieldLabel
                                    )} Column
                                  </option>
                                  {columns?.map((col, index) => (
                                    <option key={index} value={col}>{col}</option>
                                  ))}
                                </Form.Select>
                              )}
                            </div>
                          </div>
                          {item?.customField === "yes" && (
                            <div
                              style={{
                                marginTop: "8px",
                                paddingLeft: "192px"
                              }}
                            >
                              {item?.referenceRangeLowerLimit === "yes" && (
                                <CustomMappingRow
                                  fieldId={item?.id}
                                  mappingType="referenceRangeLowerLimit"
                                  label={item?.referenceRangeLowerLimitLabel}
                                  name={item?.referenceRangeLowerLimitName}
                                />
                              )}
                              {item?.referenceRangeUpperLimit === "yes" && (
                                <CustomMappingRow
                                  fieldId={item?.id}
                                  mappingType="referenceRangeUpperLimit"
                                  label={item?.referenceRangeUpperLimitLabel}
                                  name={item?.referenceRangeUpperLimitName}
                                />
                              )}
                              {item?.referenceRangeIndicator === "yes" && (
                                <CustomMappingRow
                                  fieldId={item?.id}
                                  mappingType="referenceRangeIndicator"
                                  label={item?.referenceRangeIndicatorLabel}
                                  name={item?.referenceRangeIndicatorName}
                                />
                              )}
                              {item?.clinicalSignificance === "yes" && (
                                <CustomMappingRow
                                  fieldId={item?.id}
                                  mappingType="clinicalSignificance"
                                  label={item?.clinicalSignificanceLabel}
                                  name={item?.clinicalSignificanceName}
                                />
                              )}
                              {item?.customRemark === "yes" && (
                                <CustomMappingRow
                                  fieldId={item?.id}
                                  mappingType="customRemark"
                                  label={item?.customRemarkLabel}
                                  name={item?.customRemarkName}
                                />
                              )}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
              </>
            }
          </div>
          <MapperPreview
            Show={showPreview}
            Hide={setShowPreview}
            Title="Preview"
            previewData={previewData}
            columns={columns}
            sourceData={sourceData}
            fileUniqueId={fileUniqueId}
            level={level}
          />
        </div>
      </SplitPane>
    </div>
  )
}

export default ColumnMapping